/* ============================================================
 * 定数
 * ============================================================ */

// --------------------------------------
// 端末モード
// --------------------------------------
/** PC */
export const CLIENT_PC = "PC";
/** スマホ */
export const CLIENT_SP = "SP";

// --------------------------------------
// 処理モード
// --------------------------------------
/** 画像読込・配置 */
export const MODE_PHOTO_REGIST = "PHOTO_RGST";
/** 画像入替え */
export const MODE_PHOTO_REPLACE = "PHOTO_REP";
/** 画像操作 */
export const MODE_PHOTO_MANI = "PHOTO_MANI";
/** コメント操作 */
//export const MODE_COMMENT_MANI = "COMMENT_MANI";
/** あいさつ文操作 */
export const MODE_GREETING_MANI = "GREETING_MANI";
/** 差出人操作 */
export const MODE_SENDER_MANI = "SENDER_MANI";
/** スタンプ操作 */
export const MODE_STAMP_MANI = "STAMP_MANI";
/** マイスタンプ操作 */
export const MODE_MYSTAMP_MANI = "MYSTAMP_MANI";
/** 手書きスタンプ操作 */
export const MODE_FONTGENIC_MANI = "FONTGENIC_MANI";
/** 手書きスタンプ操作 */
export const CHANGE_BRIGHT = "CHANGE_BRIGHT_MANI";

// --------------------------------------
// レイヤー区分
// --------------------------------------
/** 差出人レイヤー */
export const LTYPE_SENDER = "SENDER_LAYER";
/** 自由文レイヤー */
export const LTYPE_FREE = "FREE_LAYER";
/** スタンプレイヤー */
export const LTYPE_STAMP = "STAMP_LAYER";
/** 白フチレイヤー */
export const LTYPE_AREA = "AREA_LAYER";
/** 画像レイヤー */
export const LTYPE_PHOTO = "PHOTO_LAYER";
/** 背景レイヤー */
export const LTYPE_BG = "BG_LAYER";
/** 再編集可能レイヤーリスト */
export const LTYPES_CAN_RESELECT = [
	LTYPE_STAMP, LTYPE_SENDER, LTYPE_FREE, LTYPE_PHOTO
];

// --------------------------------------
// アイテム区分
// --------------------------------------
/** 画像枠 */
export const ITYPE_PHOTO_BOX = "PHOTO_BOX";
/** 配置画像 */
export const ITYPE_PHOTO_IMG = "PHOTO_IMG";
/** 有効領域画像 */
export const ITYPE_AREA_IMG = "AREA_IMG";
/** スタンプ */
export const ITYPE_STAMP_IMG = "STAMP_IMG";
/** マイスタンプ */
export const ITYPE_MYSTAMP_IMG = "MYSTAMP_IMG";
/** 手書きスタンプ */
export const ITYPE_FONTGENIC_IMG = "FONTGENIC_IMG";
/** コメント */
export const ITYPE_COMMENT_TXT = "COMMENT_TXT";
/** あいさつ文 */
export const ITYPE_GREETING_TXT = "GREETING_TXT";
/** 差出人 */
export const ITYPE_SENDER_TXT = "SENDER_TXT";

// --------------------------------------
// 仕上がり区分
// --------------------------------------
/** 印刷 */
export const ATYPE_PRING = "1";
/** 銀塩 */
export const ATYPE_GINEN = "2";

// --------------------------------------
// 拡大・縮小の閾値
// --------------------------------------
/** 写真上限 */
export const PHOTOP_SCALE_MAX = 1.6;
/** 写真下限（枠ぴったりＯＦＦ用） */
export const PHOTOP_SCALE_MIN = 0.25;
/** 写真枠内下限（枠ぴったりＯＦＦ用） */
export const PHOTOP_INSIDE_MIN = 0.9;
/** スタンプ上限 */
export const STAMP_SCALE_MAX = 2.0;
/** スタンプ下限 */
export const STAMP_SCALE_MIN = 0.25;
/** テキスト下限 */
export const TEXT_SCALE_MIN = 0.7;

// --------------------------------------
// SPモード用
// --------------------------------------

/** 画像操作時のパディングサイズ */
export const SP_PHOTO_MANI_PADDING = 3;
